import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatDate, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import _ from 'lodash';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  

  const readAlerts = () => {
    return new Promise(async resolve => {
      setLoading(true);
      //await callApi('read_alerts.php', {}).then(response => {
      await callGameServerApi('read-alerts', {}).then(response => {
        setLoading(false);
        if(response.status === 1) {

          resolve();
        } else {
          //appContext.tellError('Network error');
          appContext.tellError(response.msg)
        }
      })
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }

    return () => {
      readAlerts();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Alerts"/>
        <div className="FullPane"  data-support-top-bar={true} style={{ paddingBottom: "var(--topBarheight)" }}>
          <div className='container'>
            <div className='row'>
            {
              (appContext.userData.alerts && JSON.parse(appContext.userData.alerts).length > 0) ?
              JSON.parse(appContext.userData.alerts).reverse().map((item, i) => {
                //check if this alert is new
                let isNew = false;

                JSON.parse(appContext.userData.newAlerts).forEach((newAlert) => {
                  if(_.isEqual(newAlert, item)) {
                    isNew = true;
                  }
                });

                return (
                  <div
                    key={i}
                    className="col-md-12 col-sm-12"
                    style={{
                      marginTop: "10px",
                      padding: "10px",
                      borderBottom: "5px solid var(--faintBlack)"
                    }}>
                    {
                      (isNew) ?
                      <p className="font-light">{item.msg}</p>
                      :
                      <p className="font-light text-muted">{item.msg}</p>
                    }

                    {
                      (item.navable) ?
                      <div className="text-start">
                        <button
                          className="btn bg-goldish btn-rounded"
                          onClick={() => {
                            appContext.navTo({
                              item: item.navItem,
                              subItem: item.navSubItem,
                              extraItem: item.navExtraItem,
                            })
                          }}
                        >
                          Open
                        </button>
                      </div>: ""
                    }

                    <div className="text-end">
                      <small className="font-light text-goldish form-text" style={{ fontSize: "12px" }}>{formatDate(item.date)}</small>
                    </div>
                  </div>
                )
              }):
              <div className="col-md-12 col-sm-12" style={{ marginTop: "30px" }}>
                <small className="font-light text-redish">No alerts were found</small>
              </div>
            }
            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
